import httpClient from "./httpClient";

class articlePublicationDateService {
    async getYearsCount(channelGuid) {
        return httpClient(`/${channelGuid}/assets/count`);
    }
};

export default new articlePublicationDateService();